
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Nice dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO est une agence Google Ads à Nice certifiée Google Partner, accompagne les entreprises niçoises pour dynamiser leur présence en ligne et toucher plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Nice dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO est une agence Google Ads à Nice certifiée Google Partner, accompagne les entreprises niçoises pour dynamiser leur présence en ligne et toucher plus de prospects.",
        },
      ],
    };
  },
};
